import React from 'react'
import Image from 'next/image'
import { FaStar } from 'react-icons/fa'
import { s3Static } from 'utils/constants'
import { gbpUrl, googleRating, googleReviewCount } from 'utils/business-info'
import { CustomerReviews } from '@/index/commons/CustomerReviews'

// Links to the Google Business Profile, with the rating and review count from
// utils/business-info. This is visible content only. The rating must never go
// into JSON-LD aggregateRating (see utils/local-business-schema.js).
//
// variant "plain": inline, for white sections.
// variant "glass": frosted pill, for the aircon reviews section.
export const GoogleRatingBadge = ({ variant = 'plain', className = '' }) => {
    const shell = variant === 'glass'
        ? 'bg-white/70 backdrop-blur-md px-5 py-3 rounded-2xl border border-white/80 shadow-[0_2px_16px_rgba(0,0,0,0.06)]'
        : ''
    return (
        <a href={gbpUrl} target="_blank" rel="noreferrer" className={`inline-flex justify-center items-center gap-3 ${shell} ${className}`}>
            <Image
                className="rounded-xl"
                src={s3Static + "google-icon.png"}
                height={45}
                width={80}
                style={{ objectFit: 'contain', objectPosition: 'center' }}
                alt="Google Reviews for StringsSG"
            />
            <span className="flex items-center gap-1">
                <span className="text-xl font-bold text-gray-700">{googleRating}</span>
                <FaStar className="text-2xl text-amber-400" aria-hidden="true" />
                <span className="text-sm text-gray-500">from {googleReviewCount} Google reviews</span>
            </span>
        </a>
    )
}

// Reviews section: heading, optional intro, Google badge, review carousel.
export const ReviewsSection = ({ title, intro, testimonials, providerLabel }) => (
    <section className="bg-white py-10 px-4">
        <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold uppercase text-gray-800 mb-3 leading-relaxed">
                {title}
            </h2>
            {intro &&
                <p className="text-sm text-gray-600 mb-5 max-w-3xl mx-auto">{intro}</p>
            }
            <GoogleRatingBadge className="mb-4" />
            <CustomerReviews testimonials={testimonials} providerLabel={providerLabel} />
        </div>
    </section>
)
